var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRuler = function SvgRuler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.756 14.583q-.563 0-.95-.388a1.3 1.3 0 0 1-.39-.951V6.756q0-.563.39-.95.387-.39.95-.39h12.488q.563 0 .95.39.39.387.39.95v6.488q0 .563-.39.95a1.3 1.3 0 0 1-.95.39zm0-1.083h12.488a.25.25 0 0 0 .176-.08.24.24 0 0 0 .08-.176V6.756a.24.24 0 0 0-.08-.176.25.25 0 0 0-.177-.08h-2.451v3.18h-1.084V6.5h-2.166v3.18H9.458V6.5H7.292v3.18H6.208V6.5H3.756a.25.25 0 0 0-.176.08.25.25 0 0 0-.08.176v6.488q0 .096.08.176t.176.08"
  })));
};
export default SvgRuler;